import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const CardContainer = styled.div`
    width: 100%;
    border-radius: 16px;
    background-color: ${(props) => props.theme.white};
    padding: 24px;
    border: 1px solid ${(props) => props.theme.borderWhite};
    color: ${(props) => props.theme.grey};

    & label{
        color: ${(props) => props.theme.orange};
        font-weight: bold;
        font-size: ${theme.font.size18};
        padding: 0 0 16px 0;
    }

    & span{
        color: ${(props) => props.theme.grey};
        font-size: ${theme.font.size14};
    }

`;

export const AddressType = styled.div`
    color: ${(props) => props.theme.grey};
    font-weight: bold;
    font-size: ${theme.font.size14};
`;

export const Title = styled.div`
    color: ${(props) => props.theme.orange};
    font-weight: bold;
    font-size: ${theme.font.size18};
    padding: 0 0 16px 0;
`;

export const AlignAddress = styled.div`
`;
